import { ImageLoaderProps } from 'next/image';

const localImagePrefixes = ['/media/', '/_next/'];

const normalizeUrl = (url: string): string => {
  return url.replace(/([^:]\/)\/+/g, '$1');
};

function makeURL(source: string, baseUrl: string) {
  if (source.startsWith('http')) {
    return new URL(source);
  }

  const base = new URL(baseUrl);
  const target = new URL(source, base.origin);

  if (target.origin === base.origin && base.pathname !== '/') {
    target.pathname = normalizeUrl(base.pathname + target.pathname);
  }

  return target;
}

export const getMediaBaseUrl = (): string => {
  if (typeof window !== 'undefined' && window.__ENV__) {
    return window.__ENV__.API_MAGENTO_MEDIA_URL || '';
  }
  return process.env.API_MAGENTO_MEDIA_URL || '';
};

export const getPayloadBaseUrl = (): string => {
  if (typeof window !== 'undefined' && window.__ENV__) {
    return window.__ENV__.API_PAYLOAD_URL || '';
  }
  return process.env.API_PAYLOAD_URL || '';
};

/**
 * Кастомный лоадер для изображений
 * @see https://nextjs.org/docs/app/api-reference/components/image#loader
 */
export function utilImageLoader(props: ImageLoaderProps): string {
  const baseUrl = props.src.startsWith('/api/media')
    ? getPayloadBaseUrl()
    : getMediaBaseUrl();

  // Для локальных изображений из public
  if (localImagePrefixes.some((prefix) => props.src.startsWith(prefix))) {
    return props.src;
  }

  const url = makeURL(props.src, baseUrl);

  if (props.width) {
    url.searchParams.set('w', String(props.width));
  }

  if (props.quality) {
    url.searchParams.set('q', String(props.quality));
  }

  return url.toString();
}
